// extracted by mini-css-extract-plugin
export default {"container":"FilterSection-module__container--Cp1Y8","filterWrapper":"FilterSection-module__filterWrapper--mHniY"};